<template>
  <el-tabs v-model="activeName" type="border-card">
    <el-tab-pane label="合作实际承运人列表" name="teamAndDriver">
      <Designated
        v-if="activeName == 'teamAndDriver'"
        ref="myDrivers"
        :branch-code="branchCode"
        :parent-data="parentData"
        @event="setDesignated"
      />
    </el-tab-pane>
    <el-tab-pane label="指定承运分组" name="teamDriver">
      <DesignatedVehicleTeam
        v-if="activeName == 'teamDriver'"
        ref="myDriversTeam"
        :shipment-party-code="shipmentPartyCode"
        :branch-code="branchCode"
        @event="setDesignated"
      />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import Designated from "./Designated.vue";
import DesignatedVehicleTeam from "./DesignatedVehicleTeam.vue";

export default {
  name: "DesignateDriver",
  components: {
    Designated,
    DesignatedVehicleTeam
  },
  props: {
    branchCode: {
      type: String,
      default: ""
    },
    shipmentPartyCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tabPaneVal: "teamAndDriver",
      activeName: "teamAndDriver",
      tableData: [],
      loading: false,
      parentData: {}
    };
  },
  created() {},
  methods: {
    close() {
      if (this.$refs.myDrivers) {
        this.$refs.myDrivers.closes();
        this.$refs.myDrivers.funcFilter();
      } else if (this.$refs.myDriversTeam) {
        this.$refs.myDriversTeam.closeData();
        this.$refs.myDriversTeam.designcar();
      }
    },
    setDesignated(data, isTeam) {
      this.$emit("event2", data, isTeam);
    }
  }
};
</script>

<style></style>
